/**
 * DevExtreme (esm/__internal/ui/number_box/m_number_box.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import NumberBoxMask from "./m_number_box.mask";
registerComponent("dxNumberBox", NumberBoxMask);
export default NumberBoxMask;